/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { TVehicle, } from "models/inventory/interfaces/vehicle.interface";
import { PandaboardApiInstance } from "../../../helpers/api";
import { vehicleDetailData } from "../interfaces/vehicle-detail.interfaces";


export const getVehicleDetails = (vehicle: TVehicle): Promise<vehicleDetailData> =>
  PandaboardApiInstance
    .get(`vehicle-details/search?brand=${vehicle.brand._id}&model=${vehicle.model._id}&cc=${vehicle.cylindersCapacity}&year=${vehicle.year}`)
    .then((response) => response.data)
    .catch(() => null);
